module.exports = __webpack_public_path__ + "public/images/prizes/super-prize.31ceacb8529196f211319fb48bbac765.jpg";